import { config } from './config';
import { getTrfAccessToken, logoutTrfSession } from './trfService';

export async function UploadToS3(file, filename, uploadType = 'trf') {
  const formData = new FormData();
  formData.append('file', file);
  const isVialUpload = uploadType === 'vial';
  const headers = new Headers();
  const query = new URLSearchParams({ filename });

  if (isVialUpload) {
    const partnerToken = new URLSearchParams(window.location.search).get('token')
      || sessionStorage.getItem('token')
      || '';
    headers.set('incoming_api_key', partnerToken);
  } else {
    const accessToken = getTrfAccessToken();
    if (!accessToken) {
      logoutTrfSession();
      throw new Error('Missing access token');
    }
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  const endpoint = isVialUpload ? 'vial' : 'trf';
  const res = await fetch(`${config().apiHost}/api/files/${endpoint}/upload?${query}`, {
    method: 'POST',
    headers,
    body: formData,
  });
  if (!isVialUpload && res.status === 401) {
    logoutTrfSession();
  }
  if (res.status === 200) {
    return res.json();
  }
  throw Error(res.status);
}
